module.exports = __webpack_public_path__ + "static_portal/img/video_report_faq_big.96fae4d2.jpg";